module.exports = __webpack_public_path__ + "media/images/clean_powerpoint_export-c748ea16c00d97dceadcc1675383179e.png";